// extracted by mini-css-extract-plugin
export default {"menu":"App_menu__M8k5S","dropdownlist":"App_dropdownlist__6OSNm","btn":"App_btn__KB-0+","page":"App_page__W02Oo","logo":"App_logo__KFImf","login":"App_login__gMv+r"};